module.exports = __webpack_public_path__ + "img/EMT-BRCA_10X_IDC.e7962dec.png";